import { ReactElement, useContext, useEffect } from 'react';
import { ctxUser } from '../../contexts/UserContext';
import StreamChatLayer from '@/components/stream-chat/StreamChatLayer';
import StreamChatPhoneLayer from './StreamChatPhoneLayer';
import { getChatUserId } from '@/generated/client/chat/chat';
import { chatContext } from '@/contexts/ChatContext';
import { useState } from 'react';

export function StreamChatAccess({ children }: { children: ReactElement }) {
  const userCtx = useContext(ctxUser);
  const [chatId, setChatId] = useState<string | undefined>();

  useEffect(() => {
    async function setChatUserId() {
      const userId = await getChatUserId();
      setChatId(String(userId.data)); // ez a String() nem kellene, de a pluto-server egy sima szamot ad vissza
    }
    void setChatUserId();
  }, []);

  if (!userCtx || !chatId) {
    return children;
  }
  const username = userCtx.user.name;

  if (window.Logout) {
    return (
      <chatContext.Provider value={{ chatId, setChatId }}>
        <StreamChatPhoneLayer userId={chatId} userName={username}>
          {children}
        </StreamChatPhoneLayer>
      </chatContext.Provider>
    );
  }
  return (
    <chatContext.Provider value={{ chatId, setChatId }}>
      <StreamChatLayer userId={chatId} userName={username}>
        {children}
      </StreamChatLayer>
    </chatContext.Provider>
  );
}
